import { jsx } from "react/jsx-runtime";
import { TldrawUiIcon } from "../TldrawUiIcon.mjs";
function TldrawUiButtonCheck({ checked }) {
  return /* @__PURE__ */ jsx(TldrawUiIcon, { icon: checked ? "check" : "none", className: "tlui-button__icon", small: true });
}
export {
  TldrawUiButtonCheck
};
//# sourceMappingURL=TldrawUiButtonCheck.mjs.map
